import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import React from "react";
import CopyRight from "./CopyRight";
import { useNavigate } from "react-router-dom";

const FooterView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1200px",
  margin: "auto",
  padding: "16px",
  display: "flex",
  alignItems: "flex-start",
  [theme.breakpoints.down("sm")]: {
    alignItems: "center",
    flexDirection: "column",
  },

  //   justifyContent: "space-between",
  //   flexWrap: "wrap",
}));

let product = [
  // {
  //   title: "Pricing",
  //   link: "pricing",
  // },
  {
    title: "Overview",
    link: "overview",
  },
  {
    title: "Browse",
    link: "browse",
  },
  {
    title: "Accessibility",
    link: "accessibility",
  },
  {
    title: "Five",
    link: "five",
  },
];

let solution = [
  {
    title: "Brainstorming",
    link: "brainstorming",
  },
  {
    title: "Ideation",
    link: "ideation",
  },
  {
    title: "Wireframing",
    link: "wireframing",
  },
  {
    title: "Research",
    link: "research",
  },
];

let resources = [
  {
    title: "Help Center",
    link: "help-center",
  },
  {
    title: "Blog",
    link: "blog",
  },
  {
    title: "Tutorials",
    link: "tutorials",
  },
];

let company = [
  {
    title: "About",
    link: "about-us",
  },
  {
    title: "Press",
    link: "press",
  },
  {
    title: "Events",
    link: "events",
  },
  {
    title: "Careers",
    link: "careers",
  },
];

function LandingFooter() {
  const navigate = useNavigate();
  const renderFooterItems = (title, data) => {
    return (
      <Stack flex={1}>
        <Typography variant="body1" color={"#94A3B8"}>
          {title}
        </Typography>
        <List sx={{ mt: 1 }}>
          {data?.map((val, ind) => {
            return (
              <ListItem
                key={ind}
                onClick={() => navigate(`${val.link}`)}
                sx={{ px: 0, pb: 0, cursor: "pointer" }}
              >
                <ListItemText
                  primary={val.title}
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontSize: "0.875rem",
                      color: "#0F172A",
                    },
                  }}
                />
              </ListItem>
            );
          })}
        </List>
      </Stack>
    );
  };

  return (
    <>
      <FooterView>
        {/* <Box flex={0.5}>
          <Typography variant="h5" fontWeight={600} color={"primary"}>
            LOBA
          </Typography>
        </Box>

        <Stack
          flex={2}
          gap={2}
          direction={"row"}
          alignItems={"flex-start"}
          justifyContent={{ xs: "center", sm: "space-between" }}
          flexWrap={"wrap"}
          mt={{ xs: 3, sm: 0 }}
        >
          {renderFooterItems("PRODUCT", product)}
          {renderFooterItems("SOLUTIONS", solution)}
          {renderFooterItems("RESOURCES", resources)}
          {renderFooterItems("COMPANY", company)}
        </Stack> */}
      </FooterView>
      <Divider sx={{ my: 1 }} />
      <CopyRight />
    </>
  );
}

export default LandingFooter;
